{
  "name": "sage-gui",
  "version": "3.4.0",
  "description": "",
  "scripts": {
    "start": "npm start -w sage",
    "build": "npm run build -w sage",
    "test": "npx playwright test",
    "clean": "npm run clean --workspaces --if-present && rm -rf .parcel-cache/",
    "release": "standard-version",
    "old-tests": "jest"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/sagecontinuum/sage-gui"
  },
  "license": "UNLICENSED",
  "devDependencies": {
    "@playwright/test": "^1.45.1",
    "@types/node": "^20.14.10",
    "@typescript-eslint/eslint-plugin": "^5.33.1",
    "@typescript-eslint/parser": "^5.33.1",
    "eslint": "^8.22.0",
    "eslint-plugin-react": "^7.30.1",
    "eslint-plugin-react-hooks": "^4.6.0",
    "standard-version": "^9.3.0",
    "svgo": "^3.3.2",
    "tsc-files": "^1.1.4"
  },
  "standard-version": {
    "header": "# Changelog\n\nThe following are some notable changes to the UI\n\n"
  },
  "workspaces": [
    "apps/admin",
    "apps/sage",
    "apps/project",
    "apps/registration-api"
  ],
  "alias": {
    "d3": "d3/dist/d3.js"
  },
  "dependencies": {
    "@mui/icons-material": "^6.0.2",
    "@mui/material": "^6.0.2",
    "@mui/styles": "^6.0.2",
    "chart.js": "^4.4.2",
    "chartjs-adapter-date-fns": "^3.0.0",
    "chartjs-plugin-zoom": "^2.0.1"
  }
}
